module.exports = __webpack_public_path__ + "img/20.63bcae61.png";